import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.onyx,
  notFullBleed: true,
  notFullBleedBgColor: colors.whiteish,
  textColorDark: colors.onyx,
  textColorLight: colors.white
};
export default fiftyFiftyCard;